import { Suspense } from 'react';
import type { DeferredRequestKey } from '~/constants/common/deferredRequests';
import DeferredErrorBoundary from './DeferredErrorBoundary';
import { DeferredResolution } from './DeferredResolution';

type Props<T> = {
  deferredKey: DeferredRequestKey;
  onResolve: (data: T | undefined) => void;
  promise: Promise<T | undefined>;
};

export default function DeferredStreamBoundary<T>({
  deferredKey,
  onResolve,
  promise
}: Props<T>) {
  return (
    <Suspense fallback={null}>
      <DeferredErrorBoundary
        deferredKey={deferredKey}
        // On reject, fall back to the client re-fetch a miss triggers so the section isn't stranded.
        onError={() => onResolve(undefined)}
      >
        <DeferredResolution
          deferredKey={deferredKey}
          onResolve={onResolve}
          promise={promise}
        />
      </DeferredErrorBoundary>
    </Suspense>
  );
}
